import { useContext } from 'react';

import { TicketLiveDataContext } from 'src/contexts';

export const useTicketLiveData = () => useContext(TicketLiveDataContext);
